import repository from './repsitory'

const resource = '/targetAlerts'

export default {
    get () {
        return repository.get(`${resource}`)
    },
    getTargetAlertsByTargetDevice (targetDeviceId) {
        return repository.get(`${resource}/targetDevice/${targetDeviceId}`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    add (data) {
        return repository.post(`${resource}`, data)
    },
    update (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
    getAmountAlerts () {
        return repository.get(`${resource}/active/amount`)
    },
    silentAlert (data) {
        return repository.put(`${resource}/silentAlert`, data)
    },
    getCurrentAlerts (targetDeviceId) {
        return repository.get(`${resource}/currentAlerts`)
    },
}
